<template>
  <div class="service-container">
    <router-link v-for="(item, i) in services" :to="item.to" :key="i">
      <van-image class="service" :src="item.icon" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ServiceNav',
  props: {
    services: Array
  }
}
</script>

<style lang="less" scoped>
.service-container {
  padding: 4px 12px 8px 12px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: #efefef;

  a {
    margin-top: 8px;
  }

  .service {
    width: 170px;
    height: 80px;
  }
}
</style>
